import { Box, Button, Divider, Grid, Stack, Typography } from '@mui/material'
import AddNewClientComponent from '../components/Architecture/AddNewClientComponent'
import { SortIcon } from '../components/Svgs'
import RecentClientsComponent from '../components/Architecture/RecentClientsComponent'
import ClientsListComponent from '../components/Architecture/ClientsListComponent'
import { useEffect, useRef, useState } from 'react'

function Clients() {
  const gridRef = useRef<HTMLDivElement>(null)
  const [gridHeight, setGridHeight] = useState(0)

  useEffect(() => {
    const calculateHeight = () => {
      if (gridRef.current) {
        setGridHeight(gridRef.current.clientHeight)
      }
    }

    calculateHeight()
    window.addEventListener('resize', calculateHeight)

    return () => {
      window.removeEventListener('resize', calculateHeight)
    }
  }, [])

  return (
    <Box
      gap={'2.5rem'}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Grid ref={gridRef} container spacing='1rem'>
        <Grid size={3}>
          <Stack gap='1rem'>
            <Box display='flex' width='100%'>
              <Typography
                sx={{
                  color: '#06004A',
                  fontSize: '0.94rem',
                  fontWeight: 500,
                  lineHeight: 'normal',
                }}
              >
                Add New Client
              </Typography>
            </Box>
            <Box sx={{ height: '5.5rem' }}>
              <AddNewClientComponent />
            </Box>
          </Stack>
        </Grid>
        <Grid size={9}>
          <Stack gap='1rem'>
            <Box
              display='flex'
              justifyContent='space-between'
              alignItems='center'
              width='100%'
            >
              <Typography
                sx={{
                  color: '#06004A',
                  fontSize: '0.94rem',
                  fontWeight: 500,
                  lineHeight: 'normal',
                }}
              >
                Recent Clients
              </Typography>
              <Button
                disableRipple
                variant='text'
                sx={{
                  color: '#06004A',
                  fontSize: '0.76rem',
                  fontWeight: 500,
                  lineHeight: 'normal',
                  textTransform: 'capitalize',
                  p: 0,
                }}
              >
                View All Recent Clients
              </Button>
            </Box>
            <RecentClientsComponent />
          </Stack>
        </Grid>
      </Grid>
      <Stack spacing='1rem' height={`calc(100% - ${gridHeight}px - 2.5rem)`}>
        <Box display='flex' width='100%' gap='2rem' alignItems='center'>
          <Typography
            sx={{
              color: '#06004A',
              fontSize: '0.94rem',
              fontWeight: 500,
              lineHeight: 'normal',
            }}
          >
            All
          </Typography>
          <Box display='flex' gap='1rem'>
            <Box display='flex' gap='0.25rem'>
              <SortIcon color='#1705E5' />
              <Typography
                sx={{
                  color: '#797979',
                  fontSize: '0.7rem',
                  fontWeight: 500,
                  lineHeight: 'normal',
                }}
              >
                Sort
              </Typography>
            </Box>
            <Divider flexItem orientation='vertical' />
            <Typography
              sx={{
                color: '#797979',
                fontSize: '0.7rem',
                fontWeight: 500,
                lineHeight: 'normal',
              }}
            >
              ProjectStatus
            </Typography>
          </Box>
        </Box>
        <ClientsListComponent />
      </Stack>
    </Box>
  )
}

export default Clients
